import React from "react";
import { getVariantLabel } from "@leafly-com/web-utils";
import classnames from "classnames";

import currencyFormatter, {
  bigDollarSmallCentsFormatter,
  centsToDollars,
} from "@/utils/currencyFormatter";
import fullVariantSizeText from "@/utils/getFullVariantSizeText";

import { DiscountTag } from "@/components/Dispensary/DiscountTag";

export function VariantTile({
  className,
  countryCode,
  selected = false,
  variant,
  ...props
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
any) {
  const { deal, price, unit, quantity } = variant;

  const dealActive = deal?.active;
  const displayPrice = dealActive
    ? centsToDollars(deal.discountedPrice)
    : price;
  const displayUnit = fullVariantSizeText(
    getVariantLabel({
      packageSize: quantity,
      packageUnit: unit,
    }),
  );
  const [dollars, cents] =
    bigDollarSmallCentsFormatter(displayPrice, countryCode) || [];

  return (
    <div
      data-testid="variant-select__card"
      className={classnames(
        "relative h-full flex flex-col justify-end border rounded py-sm px-lg",
        {
          "bg-green-20 border-deep-green-60": selected,
          "border-light-grey": !selected,
          "min-w-[120px]": dealActive,
        },
        className,
      )}
      {...props}
    >
      {dealActive && (
        <DiscountTag
          className="top-0 right-0"
          discountLabel={deal.discountLabel}
          side="right"
          isRounded={true}
        />
      )}

      {dealActive && (
        <div className="line-through text-xs">
          {currencyFormatter(price, countryCode)}
        </div>
      )}

      <div
        data-testid="variant-select__price"
        className="flex items-start font-bold text-base"
      >
        <span>$</span>
        <span className="text-hero leading-none">{dollars}</span>
        <span>{cents}</span>
      </div>

      <span className="font-bold text-xs mt-xs">{displayUnit}</span>
    </div>
  );
}
